import { render } from "./DisplayModeToggler.vue?vue&type=template&id=77261c01"
import script from "./DisplayModeToggler.vue?vue&type=script&lang=js"
export * from "./DisplayModeToggler.vue?vue&type=script&lang=js"

import "./DisplayModeToggler.vue?vue&type=style&index=0&id=77261c01&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__